module.exports = __webpack_public_path__ + "static/media/icon_playground_trending.4d27a7e6.svg";